import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoAlert = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 106,
	height: 67,
	viewBox: "0 0 106 67",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M57.0457 16.6665H40.3791C39.274 16.6665 38.2142 17.1055 37.4328 17.8869C36.6514 18.6683 36.2124 19.7281 36.2124 20.8332V54.1665C36.2124 55.2716 36.6514 56.3314 37.4328 57.1128C38.2142 57.8942 39.274 58.3332 40.3791 58.3332H65.3791C66.4841 58.3332 67.5439 57.8942 68.3253 57.1128C69.1067 56.3314 69.5457 55.2716 69.5457 54.1665V29.1665L57.0457 16.6665Z",
			stroke: "#656565",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.0454 16.6665V29.1665H69.5454",
			stroke: "#656565",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_10880_12573)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M62.8789 42.3086C62.8789 42.6355 62.6139 42.9005 62.287 42.9005H57.0598L54.2872 49.8501C54.2008 50.0855 53.977 50.238 53.732 50.238C53.6951 50.238 53.6579 50.2346 53.6205 50.2275C53.3543 50.1769 53.1605 49.9448 53.1402 49.6746L52.5155 38.0423L50.8098 42.486C50.7323 42.7327 50.5037 42.9005 50.2452 42.9005H43.4707C43.1439 42.9005 42.8789 42.6355 42.8789 42.3086C42.8789 41.9818 43.1439 41.7168 43.4707 41.7168H49.8108L52.3098 33.9145C52.402 33.621 52.706 33.4433 53.0133 33.5164C53.2666 33.5768 53.4462 33.803 53.4658 34.0627L54.1168 46.8791L56.091 42.1046C56.1765 41.8716 56.3984 41.7167 56.6466 41.7167H62.287C62.6139 41.7167 62.8789 41.9817 62.8789 42.3086Z",
				fill: "#656565"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5325 21.1535C15.5034 21.1535 12.2255 17.8756 12.2255 13.8465C12.2255 13.1029 11.6226 12.5 10.879 12.5C10.1353 12.5 9.53245 13.1029 9.53245 13.8465C9.53245 17.8756 6.25451 21.1535 2.22541 21.1535C1.48178 21.1535 0.878906 21.7564 0.878906 22.5C0.878906 23.2437 1.48178 23.8465 2.22541 23.8465C6.2546 23.8465 9.53245 27.1245 9.53245 31.1536C9.53245 31.8972 10.1353 32.5001 10.879 32.5001C11.6226 32.5001 12.2255 31.8972 12.2255 31.1536C12.2255 27.1245 15.5034 23.8465 19.5324 23.8465C20.276 23.8465 20.8789 23.2437 20.8789 22.5C20.8789 21.7564 20.2761 21.1535 19.5325 21.1535Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.775 43.1535C99.7454 43.1535 96.4676 39.8756 96.4676 35.8465C96.4676 35.1029 95.8647 34.5 95.121 34.5C94.3774 34.5 93.7745 35.1029 93.7745 35.8465C93.7745 39.8756 90.4966 43.1535 86.4676 43.1535C85.724 43.1535 85.1211 43.7564 85.1211 44.5C85.1211 45.2437 85.724 45.8465 86.4676 45.8465C90.4967 45.8465 93.7745 49.1245 93.7745 53.1536C93.7745 53.8972 94.3774 54.5001 95.121 54.5001C95.8647 54.5001 96.4676 53.8972 96.4676 53.1536C96.4676 49.1245 99.7455 45.8465 103.775 45.8465C104.518 45.8465 105.121 45.2437 105.121 44.5C105.121 43.7564 104.518 43.1535 103.775 43.1535Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.4694 8.40941V7.90941H76.9694H74.7884C74.01 7.90941 73.3789 7.27833 73.3789 6.49994C73.3789 5.72154 74.01 5.09047 74.7884 5.09047H76.9694H77.4694V4.59047V2.40947C77.4694 1.63108 78.1004 1 78.8788 1C79.6572 1 80.2883 1.63108 80.2883 2.40947V4.59047V5.09047H80.7883H82.9694C83.7478 5.09047 84.3789 5.72154 84.3789 6.49994C84.3789 7.27833 83.7478 7.90941 82.9694 7.90941H80.7883H80.2883V8.40941V10.5904C80.2883 11.3688 79.6572 11.9999 78.8788 11.9999C78.1004 11.9999 77.4694 11.3688 77.4694 10.5904V8.40941Z",
			fill: "#EBEBEB",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4694 62.4094V61.9094H12.9694H10.7884C10.01 61.9094 9.37891 61.2783 9.37891 60.4999C9.37891 59.7215 10.01 59.0905 10.7884 59.0905H12.9694H13.4694V58.5905V56.4095C13.4694 55.6311 14.1004 55 14.8788 55C15.6572 55 16.2883 55.6311 16.2883 56.4095V58.5905V59.0905H16.7883H18.9694C19.7478 59.0905 20.3789 59.7215 20.3789 60.4999C20.3789 61.2783 19.7478 61.9094 18.9694 61.9094H16.7883H16.2883V62.4094V64.5904C16.2883 65.3688 15.6572 65.9999 14.8788 65.9999C14.1004 65.9999 13.4694 65.3688 13.4694 64.5904V62.4094Z",
			fill: "#EBEBEB",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10880_12573",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(42.8789 31.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNoAlert);
export default ForwardRef;
